module.exports = __webpack_public_path__ + "img/electric-ireland.500a2de.svg";